import './index.css'

export default function SimpleEditor({ name, value, label, disabled, handleChange }: any) {
  return (
    <div className='simple-editor-box'>
      {label && (<div className='simple-editor-label'>{label}</div>)}
      <textarea
        className={`entities-action-form-textarea${disabled ? ' disabled' : ''}`}
        onChange={handleChange}
        disabled={disabled}
        name={name}
        value={value}>
      </textarea>
    </div>
  )
}